import React from "react";
import { Image } from "react-bootstrap";
import { PageHeader } from "CommonComponent";
import AccessRights from "utils/AccessRights";
import { useSelector } from "react-redux";

const ListHeader = ({ setAddEditModalShow }) => {
  const session = useSelector((state) => state.session);

  return (
    <PageHeader title="Roles">
      {AccessRights(session.current_page_permissions, "add") ? (
        <button
          type="button"
          className="add-new-btn"
          onClick={() => setAddEditModalShow(true)}
        >
          <Image src="/assets/images/add-icon.svg" className="me-2 add-user-icon" alt="" aria-hidden="true" />
          Add New
        </button>
      ) : null}
    </PageHeader>
  );
};

export default ListHeader;
